import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import { AppModule } from './app/app.module';
// Load config and version before bootstrapping
Promise.all([
  fetch('./app-config.json').then((response) => response.json()),
  fetch('./version.json').then((response) => response.json()),
])
  .then(([config, version]) => {
    const releaseVersion = (version && version.WEB_VERSION) || 'unknown';

    Sentry.init({
      dsn: config.SENTRY.DSN,
      debug: config.SENTRY.DEBUG,
      release: `osos-web@${releaseVersion}`,
      environment: config.SENTRY.ENVIRONMENT,

      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      tracesSampleRate: config.SENTRY.TRACES_SAMPLE_RATE,
      replaysSessionSampleRate: config.SENTRY.REPLAYS_SESSION_SAMPLE_RATE,
      replaysOnErrorSampleRate: config.SENTRY.REPLAYS_ON_ERROR_SAMPLE_RATE,
    });

    // Bootstrap Angular after config is loaded
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  })
  .catch((err) => {
    console.error('Failed to load app config/version:', err);
    // Bootstrap even if loading fails
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  });
